import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { Colors, Typography } from '../../shared/theme/styles.enum';
import { drawerWidth } from '../sideNav/sideNav.styles';

const mobileBreakpoint = '@media (max-width:768px)';

export const useStyles = makeStyles((theme: Theme) => {
  const secondary: any = theme.palette.secondary;
  return createStyles({
    root: {
      display: 'flex',
      backgroundColor: '#f5f6f8',
      minHeight: '100vh',
      justifyContent: 'center',
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      alignItems: 'center',
      justifyContent: 'center',
      height: "auto",
      backgroundColor: secondary.main,
      boxShadow: '0 2px 12px rgba(0,0,0,0.12)',
      [mobileBreakpoint]: {
        height: 60,
      },
    },
    appBarWithNotification: {
      height: 80 + 26,
      [mobileBreakpoint]: {
        height: 60 + 26,
      },
    },
    navbar: {
      width: '90%',
      maxWidth: '90%',
      padding: 0,
      '@media (max-width:950px)': {
        maxWidth: '100% !important',
      },
    },
    hamburgerButton: {
      display: 'none',
      [mobileBreakpoint]: {
        display: 'flex',
        padding: 8,
      },
    },
    menuButton: {
      marginRight: theme.spacing(1),
      display: 'none',
    },
    ifiLogo: {
      fontSize: '56px',
      [mobileBreakpoint]: {
        fontSize: '40px',
      },
    },
    content: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: 74,
      backgroundColor: Colors.White,
      width: '90%',
      borderRadius: '12px 12px 0 0',
      boxShadow: '0 -2px 20px rgba(0,0,0,0.04)',
      '@media (max-width:950px)': {
        width: '100%',
      },
      [mobileBreakpoint]: {
        marginTop: 60,
        width: '100%',
        flexDirection: 'column',
        overflowX: 'auto',
      },
    },
    contentWithNotification: {
      marginTop: 80 + 27,
      [mobileBreakpoint]: {
        marginTop: 60 + 27,
      },
    },
    menuItem: {
      fontSize: Typography.H4,
      fontFamily: Typography.FontFamily2,
      fontWeight: 'bold',
      padding: '.1rem',
    },
    menu: {
      color: `${theme.palette.secondary.contrastText} !important`,
      opacity: '0.6',
      textDecoration: 'none !important',
      transition: 'opacity 0.2s ease !important',
      '&:hover': {
        opacity: '0.85',
      },
    },
    menuActive: {
      color: `${theme.palette.secondary.contrastText} !important`,
      opacity: '1',
      borderBottom: `3px solid ${theme.palette.primary.main} !important`,
      paddingBottom: '1px',
    },
    buttonLink: {
      color: Colors.BorderAndBG,
      textDecoration: 'none !important',
    },
    container: {
      marginTop: '80px !important',
      alignItems: 'center !important',
    },
    box: {
      width: '90%',
      display: 'grid',
      gridTemplateColumns: '352px 1fr',
      alignItems: 'center',
      padding: 0,
      margin: 0,
      [mobileBreakpoint]: {
        width: '100%',
        gridTemplateColumns: '1fr auto',
        padding: '0 8px',
      },
    },
    leftSection: {
      display: 'flex',
      alignItems: 'center',
      gap: 4,
    },
    logoContainer: {
      display: 'flex',
      alignContent: 'flex-start',
      width: drawerWidth,
      margin: 0,
      padding: 0,
      [mobileBreakpoint]: {
        width: 'auto',
      },
    },
    optionsContainer: {
      display: 'flex',
      alignItems: 'center',
      margin: 0,
      padding: 0,
      width: '100%',
      [mobileBreakpoint]: {
        justifyContent: 'flex-end',
      },
    },
    menuOptionsContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignContent: 'center',
      width: '100%',
      [mobileBreakpoint]: {
        display: 'none',
      },
    },
    selectMenuContainer: {
      display: 'flex',
      width: '100%',
      alignContent: 'center',
      justifyContent: 'flex-end',
      [mobileBreakpoint]: {
        width: 'auto',
      },
    },
    clickable: {
      cursor: 'pointer'
    }
  });
});
